// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__2hE3Y","footer":"ModalError_footer__16sjE"};